/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Revenue_Switch_To_UsdInputs */



/**
* | output |
* | --- |
* | "Switch On-Chain Revenue to USD" |
*
* @param {Metric_Revenue_Switch_To_UsdInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_revenue_switch_to_usd = /** @type {((inputs?: Metric_Revenue_Switch_To_UsdInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Revenue_Switch_To_UsdInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Switch On-Chain Revenue to USD")
});